
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M995 995v-.898.898zM995 995v-.898.898z"}}),_c('circle',{attrs:{"cx":"147.959","cy":"730.917","r":"141.987","fill":"currentColor"}}),_c('path',{attrs:{"d":"M990 412.085h-52.008a158.277 158.277 0 01-53.727 266.596 158.377 158.377 0 00-41.35-174.456h52.009l-33.36-92.14-14.612-40.232-3.77-10.408 51.709-122.665H205.373l8.907-24.57 24.603-67.554H990l-51.708 122.665z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M799.831 597.383h-52.025a158.243 158.243 0 11-234.27 24.286l-153.09-55.778L10 438.373l14.095-38.865 24.603-67.554H799.83l-20.266 47.989-9.64 22.851-21.885 51.825 3.336 9.324 14.612 40.282z","fill":"currentColor"}})])
          )
        }
      }
    